import AddressUtils from '@/lib/addressUtils';
import IAddressLine from '@/models/Shared/IAddressLine';

export default (value: IAddressLine) => {
    if (value != null) {
        return AddressUtils.fullAddressLine(value);
    }
} 